<template>
  <b-container v-if="config" fluid>
    <b-row class="mb-3">
      <b-col>
        <div class="search_input">
          <span class="fa fa-search search_input-icon"></span>
          <input
            v-model="searchString"
            type="text"
            class="form-control tsny_input search_input-input"
            :placeholder="
              'Search ' + config.type + (config.type === 'student' ? 's' : '')
            "
          />
        </div>
      </b-col>
      <b-col>
        <b-button
          class="tsny_button"
          :disabled="viewProfileDisabled"
          @click="viewProfile"
          >View Profile</b-button
        >
      </b-col>
      <b-col>
        <div class="input-group">
          <input
            v-model="email"
            type="email"
            class="form-control"
            :placeholder="'Enter ' + config.type + ' email'"
            :aria-placeholder="'Enter ' + config.type + ' email'"
            aria-describedby="basic-addon2"
          />
          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary"
              type="button"
              @click="generateSignupToken"
            >
              Create sign-up token
            </button>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          class="tsny_text-mid text-center"
          thead-tr-class="tsny_table-head"
          tbody-tr-class="tsny_table-body"
          borderless
          selectable
          striped
          :select-mode="'single'"
          :items="config.data"
          :fields="config.fields"
          :filter="searchString"
          @row-selected="rowSelected"
        >
          <template v-slot:cell(avatar)="data">
            <avatar :avatar="data.value" :width="2" />
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AccountRestService from "../../services/rest/services/AccountRestService";
import Avatar from "../Avatar";

export default {
  name: "UserAdminTab",
  components: { Avatar },
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      selected: null,
      searchString: null,
      email: null
    };
  },
  computed: {
    viewProfileDisabled: function() {
      return !this.selected || !Object.keys(this.selected).length;
    }
  },
  methods: {
    generateSignupToken: function() {
      let $comp = this;

      return AccountRestService.generateSignupToken(
        $comp.email,
        $comp.config.type
      )
        .then(response => {
          $comp.$emit("token-created", response.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    rowSelected: function(items) {
      if (items.length) {
        this.selected = items[0];
      } else {
        this.selected = {};
      }
    },
    viewProfile: function() {
      this.$router.replace({
        name: "Profile",
        params: { user: this.selected.email }
      });
    }
  }
};
</script>

<style scoped></style>
